import modelImage from "img/partners/model.webp";
import React from "react";
import { Heading } from "web/react/emo/heading/heading";
import { Text } from "web/react/emo/text/text";
import { VStack } from "web/react/emo/v-stack/v-stack";
import { useSectionImpression } from "web/react/pages/partners/use-section-impression";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import * as styles from "./partners-model.css";

const BULLETS = [
    gettextNoop("partners.model.bullet_1"),
    gettextNoop("partners.model.bullet_2"),
    gettextNoop("partners.model.bullet_3"),
    gettextNoop("partners.model.bullet_4"),
    gettextNoop("partners.model.bullet_5"),
    gettextNoop("partners.model.bullet_6"),
] as const;

export default function PartnersModel(): JSX.Element {
    const sectionRef = useSectionImpression("the_model", 2);

    return (
        <section ref={sectionRef} id="the-model" className={styles.section}>
            <div className={styles.inner}>
                <div className={styles.left}>
                    <VStack spacing="xl">
                        <VStack spacing="xs">
                            <Text
                                textStyle="caption-s"
                                color="secondary"
                                className={styles.eyebrow}
                            >
                                {gettext("partners.nav.the_model")}
                            </Text>
                            <Heading textStyle="hero-l" as="h2">
                                {gettext("partners.model.headline")}
                            </Heading>
                        </VStack>

                        <VStack spacing="md">
                            <Heading textStyle="hero-xs" as="h3">
                                {gettext("partners.model.sub_headline")}
                            </Heading>

                            <VStack spacing="lg">
                                <ul className={styles.bulletList}>
                                    {BULLETS.map((key) => (
                                        <li key={key} className={styles.bulletItem}>
                                            <Text textStyle="body" color="secondary" as="span">
                                                {"·"}
                                            </Text>
                                            <Text textStyle="body" color="secondary" as="span">
                                                {gettext(key)}
                                            </Text>
                                        </li>
                                    ))}
                                </ul>

                                <div className={styles.stat}>
                                    <Heading textStyle="hero-xl">{"4.64%"}</Heading>
                                    <Text textStyle="body-bold">
                                        {gettext("partners.model.stat_label")}
                                    </Text>
                                </div>
                            </VStack>
                        </VStack>
                    </VStack>
                </div>

                <div className={styles.imageContainer}>
                    <img src={modelImage} alt="" className={styles.image} loading="lazy" />
                </div>
            </div>
        </section>
    );
}
